/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../basicEmailMarketing.module.ts" />

module Meevo.Plugins.BasicEmailMarketing {

    interface IPurchasedANotBModel {
        ServiceId: string[];
        ServiceCategoryId: string[];
        ProductId: string[];
        ProductCategoryId: string[];
        NotServiceId: string[];
        NotServiceCategoryId: string[];
        NotProductId: string[];
        NotProductCategoryId: string[];
    }

    export interface IPurchasedANotB {
        service: Model.Service;
        product: Model.Product;
        serviceCategory: Model.ServiceCategory;
        productCategory: Model.ProductCategory;
        notService: Model.Service;
        notProduct: Model.Product;
        notServiceCategory: Model.ServiceCategory;
        notProductCategory: Model.ProductCategory;
        includeInactiveServices?: boolean;
        includeDiscontinuedProducts?: boolean;

        fullModel: IPurchasedANotBModel;

        clearModel(clientSelectionId: BasicMarketingClientSelectionEnum): void;
    }

    export class PurchasedANotB implements IPurchasedANotB {
        public service: Model.Service;
        public product: Model.Product;
        public serviceCategory: Model.ServiceCategory;
        public productCategory: Model.ProductCategory;
        public notService: Model.Service;
        public notProduct: Model.Product;
        public notServiceCategory: Model.ServiceCategory;
        public notProductCategory: Model.ProductCategory;
        protected _includeInactiveServices: boolean;
        protected _includeDiscontinuedProducts: boolean;

        private anyService: Model.Service;
        private anyActiveService: Model.Service;
        private anyProduct: Model.Product;
        private anyActiveProduct: Model.Product;
        private anyServiceCategory: Model.ServiceCategory;
        private anyActiveServiceCategory: Model.ServiceCategory;
        private anyProductCategory: Model.ProductCategory;

        public get fullModel(): IPurchasedANotBModel {
            return {
                ServiceId: (this.service && this.service.id) ? [this.service.id] : null,
                ServiceCategoryId: (this.serviceCategory && this.serviceCategory.id) ? [this.serviceCategory.id] : null,
                ProductId: (this.product && this.product.id) ? [this.product.id] : null,
                ProductCategoryId: (this.productCategory && this.productCategory.id) ? [this.productCategory.id] : null,
                NotServiceId: (this.notService && this.notService.id) ? [this.notService.id] : null,
                NotServiceCategoryId: (this.notServiceCategory && this.notServiceCategory.id) ? [this.notServiceCategory.id] : null,
                NotProductId: (this.notProduct && this.notProduct.id) ? [this.notProduct.id] : null,
                NotProductCategoryId: (this.notProductCategory && this.notProductCategory.id) ? [this.notProductCategory.id] : null,
            };
        }

        public get includeInactiveServices(): boolean {
            return this._includeInactiveServices;
        }

        public set includeInactiveServices(newValue) {
            this._includeInactiveServices = newValue;
        }

        public get includeDiscontinuedProducts(): boolean {
            return this._includeDiscontinuedProducts;
        }

        public set includeDiscontinuedProducts(newValue) {
             this._includeDiscontinuedProducts = newValue;
        }

        constructor(private $translate: ng.translate.ITranslateService) {
            this.anyService = {id: null, displayName: this.$translate.instant('LABEL_ANY_SERVICE')};
            this.anyActiveService = { id: null, displayName: this.$translate.instant('LABEL_ANY_ACTIVE_SERVICE') };
            this.anyProduct = {id: null, displayName: this.$translate.instant('LABEL_ANY_PRODUCT')}; 
            this.anyActiveProduct = { id: null, displayName: this.$translate.instant('LABEL_ANY_NOT_DISCONTINUED_PRODUCT')};
            this.anyServiceCategory = {id: null, displayName: this.$translate.instant('LABEL_ANY_SERVICE_CATEGORY')};
            this.anyActiveServiceCategory = { id: null, displayName: this.$translate.instant('LABEL_ANY_ACTIVE_SERVICE_CATEGORY') };
            this.anyProductCategory = {id: null, displayName: this.$translate.instant('LABEL_ANY_PRODUCT_CATEGORY')};

            this.clearModel(null);
        }

        public clearModel(clientSelectionId: BasicMarketingClientSelectionEnum): void {
            this.service = null;
            this.product = null;
            this.serviceCategory = null;
            this.productCategory = null;
            this.notService = null;
            this.notProduct = null;
            this.notServiceCategory = null;
            this.notProductCategory = null;
            this.includeInactiveServices = false;
            this.includeDiscontinuedProducts = false;
            switch (clientSelectionId) {
                case Meevo.Model.BasicMarketingClientSelectionEnum.ClientsPurchasedServiceAnotServiceB:
                    this.service = {...this.anyService};
                    this.serviceCategory = {...this.anyServiceCategory};
                    this.notService = {...this.anyService};
                    this.notServiceCategory = null;
                    break;
                case Meevo.Model.BasicMarketingClientSelectionEnum.ClientsPurchasedProductAnotProductB:
                    this.product = {...this.anyActiveProduct };
                    this.productCategory = {...this.anyProductCategory};
                    this.notProduct = {...this.anyActiveProduct};
                    this.notProductCategory = null;
                    break;
                case Meevo.Model.BasicMarketingClientSelectionEnum.ClientsPurchasedServiceNotProduct:
                    this.service = {...this.anyActiveService};
                    this.serviceCategory = {...this.anyActiveServiceCategory};
                    this.notProduct = {...this.anyActiveProduct };
                    this.notProductCategory = {...this.anyProductCategory};
                    break;
            }
        }
    }
}
